<div
    class="zop-vertical-navigation-item-wrapper"
    [class.zop-vertical-navigation-item-has-subtitle]="!!item.subtitle"
    [ngClass]="item.classes?.wrapper"
>
    <div
        class="zop-vertical-navigation-item"
        [ngClass]="{ 'zop-vertical-navigation-item-disabled': item.disabled }"
        [matTooltip]="item.tooltip | transloco"
        (click)="toggleCollapsable()"
    >
        <!-- Icon -->
        <ng-container *ngIf="item.icon">
            <mat-icon
                class="zop-vertical-navigation-item-icon"
                [ngClass]="item.classes?.icon"
                [svgIcon]="item.icon"
            ></mat-icon>
        </ng-container>

        <!-- Title & Subtitle -->
        <div class="zop-vertical-navigation-item-title-wrapper">
            <div class="zop-vertical-navigation-item-title">
                <span [ngClass]="item.classes?.title">
                    {{ item.title | transloco }}
                </span>
            </div>
            <ng-container *ngIf="item.subtitle">
                <div class="zop-vertical-navigation-item-subtitle">
                    <span [ngClass]="item.classes?.subtitle">
                        {{ item.subtitle | transloco }}
                    </span>
                </div>
            </ng-container>
        </div>

        <!-- Badge -->
        <ng-container *ngIf="item.badge">
            <div class="zop-vertical-navigation-item-badge">
                <div
                    class="zop-vertical-navigation-item-badge-content"
                    [ngClass]="item.badge.classes"
                >
                    {{ item.badge.title | transloco }}
                </div>
            </div>
        </ng-container>

        <!-- Arrow -->
        <mat-icon
            class="zop-vertical-navigation-item-arrow icon-size-4 text-white"
            [svgIcon]="'heroicons_solid:chevron-right'"
        ></mat-icon>
    </div>
</div>

<div
    class="zop-vertical-navigation-item-children"
    *ngIf="!isCollapsed"
    @expandCollapse
>
    <ng-container *ngFor="let item of item.children; trackBy: trackByFn">
        <!-- Skip the hidden items -->
        <ng-container
            *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden"
        >
            <!-- Basic -->
            <ng-container *ngIf="item.type === 'basic'">
                <zop-vertical-navigation-basic-item
                    [item]="item"
                    [name]="name"
                ></zop-vertical-navigation-basic-item>
            </ng-container>

            <!-- Collapsable -->
            <ng-container *ngIf="item.type === 'collapsable'">
                <zop-vertical-navigation-collapsable-item
                    [item]="item"
                    [name]="name"
                    [autoCollapse]="autoCollapse"
                ></zop-vertical-navigation-collapsable-item>
            </ng-container>

            <!-- Divider -->
            <ng-container *ngIf="item.type === 'divider'">
                <zop-vertical-navigation-divider-item
                    [item]="item"
                    [name]="name"
                ></zop-vertical-navigation-divider-item>
            </ng-container>

            <!-- Group -->
            <ng-container *ngIf="item.type === 'group'">
                <zop-vertical-navigation-group-item
                    [item]="item"
                    [name]="name"
                ></zop-vertical-navigation-group-item>
            </ng-container>

            <!-- Spacer -->
            <ng-container *ngIf="item.type === 'spacer'">
                <zop-vertical-navigation-spacer-item
                    [item]="item"
                    [name]="name"
                ></zop-vertical-navigation-spacer-item>
            </ng-container>
        </ng-container>
    </ng-container>
</div>
